import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationConfirmRegistrationArgs,
  BackendUserAuthStatus,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ConfirmRegistration($confirmationToken: String!, $confirmationDevice: String) {
    confirmRegistration(
      confirmationToken: $confirmationToken
      confirmationDevice: $confirmationDevice
    ) {
      token
    }
  }
`;

type Variables = BackendMutationConfirmRegistrationArgs;
type Result = BackendUserAuthStatus;

export const confirmRegistration = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
